import { plusRefinementKeyToAttribute } from '../plus-search/search-filter-keys';

/**
 * Maps URL/refinement keys to Typesense numeric attribute names.
 * The "new jobs" control stores thresholds under `firstSeenMin` (historically `lastSeenMin`), but
 * the intended product meaning is "first seen by the crawler within this window", so Typesense
 * filters use `firstSeen`. `postedDate` can be backdated or absent and `lastSeen` moves on every
 * re-crawl, so neither is a reliable "new today" signal.
 */
export function refinementKeyToAlgoliaNumericAttribute(key: string): string {
  // `lastSeenMin` is kept as a deprecated alias so pre-existing shareable/bookmarked URLs keep
  // resolving to the same (now-correct) `firstSeen` filter instead of silently dropping.
  if (key === 'firstSeenMin' || key === 'lastSeenMin') return 'firstSeen';
  // Plus round 3 views that share an index field (weeklyHoursAtMost/AtLeast -> weeklyHoursMin).
  return plusRefinementKeyToAttribute(key);
}
